/** @file Maps a URL pathname to one of the shell routes (/login, /, /p/:id, /settings). */

/** Every screen the shell can show; `notFound` keeps the path for the message. */
export type Route =
  | { name: 'login' }
  | { name: 'projects' }
  | { name: 'settings' }
  | { name: 'editor'; projectId: string }
  | { name: 'notFound'; path: string };

const FIXED: Record<string, Route | undefined> = { '/': { name: 'projects' }, '/login': { name: 'login' }, '/settings': { name: 'settings' } };
const EDITOR = /^\/p\/([^/]+)$/;

function decode(segment: string): string | null {
  try {
    return decodeURIComponent(segment);
  } catch {
    return null;
  }
}

/** Parses a pathname (no query or hash) ignoring one trailing slash; unknown or malformed paths become `notFound`. */
export function parseRoute(pathname: string): Route {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const fixed = FIXED[path];
  if (fixed) return fixed;
  const segment = EDITOR.exec(path)?.[1];
  const projectId = segment === undefined ? null : decode(segment);
  return projectId ? { name: 'editor', projectId } : { name: 'notFound', path: pathname };
}
